<script lang="ts">
	import { LargeProgressBar } from "misc-ui"

	interface Props {
		progress: number
		/** The bytes are uploaded and the server is moving them into the project; processing has not started yet */
		finalizing?: boolean
	}

	let { progress, finalizing = false }: Props = $props()
</script>

{#if finalizing}
	<h3 class="upload-header">Finalizing Upload</h3>

	<p>
		Your file is uploaded. The server is moving it into your project, which can take a minute for
		a large show. Processing starts automatically when that finishes.
	</p>

	<LargeProgressBar percentage={0} />
{:else}
	<h3 class="upload-header">Processing Upload</h3>

	<p>
		Your scene is currently being processed to create thumbnails and ensure the correct resolution.
	</p>

	<LargeProgressBar percentage={progress} showPercentage />
{/if}

<style>
	p {
		color: var(--color-text);
		margin-bottom: auto;
	}

	:global(.scene-uploader) h3.upload-header {
		margin-bottom: 0.5rem;
	}
</style>
